export default __webpack_public_path__ + "static/media/03-travel by car.7d4b4103.svg";